import * as React from "react";
import type { SellerAnalysis } from "@/data/sellerAnalysisTypes";
import { SA_Hero } from "@/components/analysis/SA_Hero";
import { SA_PropertySummary } from "@/components/analysis/SA_PropertySummary";
import { SA_MarketGlance } from "@/components/analysis/SA_MarketGlance";
import { SA_Comps } from "@/components/analysis/SA_Comps";
import { SA_Methodology } from "@/components/analysis/SA_Methodology";
import { SA_NetProceeds } from "@/components/analysis/SA_NetProceeds";
import { SA_Scenarios } from "@/components/analysis/SA_Scenarios";
import { SA_Strategy } from "@/components/analysis/SA_Strategy";
import { SA_Timeline } from "@/components/analysis/SA_Timeline";
import { SA_AgentStory } from "@/components/analysis/SA_AgentStory";
import { SA_Recommendation } from "@/components/analysis/SA_Recommendation";
import { SA_CTA } from "@/components/analysis/SA_CTA";
import { PresentationFooter } from "@/components/presentation/PresentationFooter";

interface Props {
  data: SellerAnalysis;
}

// SELLER_ANALYSIS template. Each section renders from the typed data object
// and self-hides when its data is missing (net proceeds / scenarios are optional).
export const SellerAnalysisTemplate: React.FC<Props> = ({ data }) => {
  return (
    <div data-testid="seller-analysis-template">
      <SA_Hero data={data} />
      <SA_PropertySummary property={data.property} />
      <SA_MarketGlance valuation={data.valuation} />
      <SA_Comps comps={data.comps} intro={data.compsIntro} />
      <SA_Methodology methodology={data.methodology} intro={data.methodologyIntro} />
      {data.netProceeds && <SA_NetProceeds netProceeds={data.netProceeds} />}
      {data.scenarios?.length ? <SA_Scenarios scenarios={data.scenarios} /> : null}
      <SA_Strategy strategy={data.strategy} intro={data.strategyIntro} />
      <SA_Timeline timeline={data.timeline} intro={data.timelineIntro} />
      <SA_AgentStory agent={data.agent} />
      {data.recommendation && (
        <SA_Recommendation recommendation={data.recommendation} agent={data.agent} />
      )}
      <SA_CTA
        agent={data.agent}
        headline={data.contact?.headline}
        body={data.contact?.body}
      />
      <PresentationFooter agent={{ name: data.agent.name, brokerage: data.agent.brokerage }} />
    </div>
  );
};
